import { Button, Stack, Typography } from '@mui/material'
import BonaShipWhiteSvg from '~/@ui/_sharedSvgs/BonashipWhite.svg?url'
import BWhiteSvg from '~/@ui/_sharedSvgs/BWhite.svg?url'
import { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import MenuWhiteSvg from '~/@ui/_sharedSvgs/ui/MenuWhite.svg?url'
import CCloseSvg from '~/@ui/_sharedSvgs/ui/c_Close.svg?react'
import SubMenuSvg from '~/@ui/_sharedSvgs/ui/SubMenu.svg?react'
import IdCardSvg from '~/@ui/_sharedSvgs/ui/IdCard.svg?react'
import { IUser } from '~/@api/generated-api-types/global.types'

interface Props {
  user: IUser | null
}

export const TopNavigationInvestor = ({ user }: Props) => {
  const navigate = useNavigate()
  const location = useLocation()
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  // Disable/enable body scroll when menu opens/closes
  useEffect(() => {
    if (isMenuOpen) {
      const originalOverflow = document.body.style.overflow
      document.body.style.overflow = 'hidden'

      return () => {
        document.body.style.overflow = originalOverflow
      }
    }
  }, [isMenuOpen])

  const toggleMenu = () => setIsMenuOpen((prev) => !prev)

  const handleNavigation = (path: string) => {
    if (location.pathname === path) {
      setIsMenuOpen(false)
    } else {
      navigate(path)
      setIsMenuOpen(false)
    }
  }

  return (
    <Stack className="flex-row w-full justify-center bg-zBlack200">
      <Stack className="flex-row w-full max-w-[768px] h-[70px] px-6 pt-2 gap-2.5 self-center items-center justify-between">
        <img
          src={BonaShipWhiteSvg}
          alt="Bonaship logo"
          className="h-7 cursor-pointer"
          onClick={() => handleNavigation('/investor/portfolio/overview')}
        />
        <img
          src={MenuWhiteSvg}
          alt="MenuWhiteSvg"
          className="cursor-pointer"
          onClick={toggleMenu}
        />
      </Stack>
      {isMenuOpen && (
        <Stack className="fixed top-0 left-0 w-screen min-h-screen z-[60] bg-gradient-to-br from-zBlack200 via-zBlack200 to-[#2d182e]">
          <Stack className="border-b border-zGrey350">
            <Stack className="w-full max-w-[768px] flex-row h-[70px] items-center justify-between px-6 pt-2 self-center">
              <img
                src={BWhiteSvg}
                alt="Bonaship logo"
                className="h-7 cursor-pointer"
                onClick={() => handleNavigation('/investor/portfolio/overview')}
              />
              <CCloseSvg
                className="w-6 h-6 stroke-zWhite200 cursor-pointer"
                onClick={toggleMenu}
              />
            </Stack>
          </Stack>

          <Stack className="w-full max-w-[768px] self-center items-center px-6 pt-8 pb-28">
            <Stack className="w-full">
              <Stack className="gap-4 mb-[22px]">
                <Stack className="flex-row items-center gap-2 mb-2">
                  <SubMenuSvg />
                  <Typography className="text-3d font-semibold text-zGrey400">
                    Menu
                  </Typography>
                </Stack>
                <Stack className="gap-3.5">
                  <Typography
                    className="text-xl font-semibold text-zWhite200 cursor-pointer"
                    onClick={() =>
                      handleNavigation('/investor/portfolio/overview')
                    }>
                    Prehľad účtu
                  </Typography>
                  <Typography
                    className="text-xl font-semibold text-zWhite200 cursor-pointer"
                    onClick={() =>
                      handleNavigation('/investor/portfolio/investments')
                    }>
                    Investície
                  </Typography>
                  <Typography
                    className="text-xl font-semibold text-zWhite200 cursor-pointer"
                    onClick={() =>
                      handleNavigation('/investor/portfolio/transactions')
                    }>
                    Transakcie
                  </Typography>
                  <Typography
                    className="text-xl font-semibold text-zWhite200 cursor-pointer"
                    onClick={() => handleNavigation('/investor/add-funds')}>
                    Pridať prostriedky
                  </Typography>
                  <Typography
                    className="text-xl font-semibold text-zWhite200 cursor-pointer"
                    onClick={() => handleNavigation('/investor/faq')}>
                    FAQ
                  </Typography>
                </Stack>
              </Stack>

              <Stack className="gap-4 mb-16">
                <Stack className="flex-row items-center gap-1.5 mb-2.5">
                  <IdCardSvg />
                  <Typography className="flex text-3d font-semibold text-zGrey400">
                    Môj účet
                  </Typography>
                </Stack>
                <Stack className="gap-[17px]">
                  <Typography
                    className="text-sm font-bold text-zWhite200 cursor-pointer"
                    onClick={() => handleNavigation('/investor/user-profile')}>
                    Používateľský profil
                  </Typography>
                  {/* <Typography
                    className="text-sm font-bold text-zWhite200 cursor-pointer"
                    onClick={() =>
                      handleNavigation('/investor/user-profile/documents')
                    }>
                    Dokumenty
                  </Typography> */}
                  <Typography
                    className="text-sm font-bold text-zWhite200 cursor-pointer"
                    onClick={() => handleNavigation('/investor/help-center')}>
                    Centrum pomoci
                  </Typography>
                  {user?.isOwner && (
                    <Typography
                      className="text-sm font-bold text-zWhite200 cursor-pointer"
                      onClick={() =>
                        handleNavigation('/vlastnik/portfolio/overview')
                      }>
                      Prepnúť na účet seniora
                    </Typography>
                  )}
                </Stack>
              </Stack>

              <Button
                variant="contained"
                className="h-[56px] bg-zWhite200"
                onClick={() => handleNavigation('/investor/opportunities')}>
                <Typography className="text-base font-medium text-zBlack300">
                  {user?._investorProfile?._investmentOrdersCount
                    ? 'Investovať'
                    : 'Prvá investícia'}
                </Typography>
              </Button>
            </Stack>
          </Stack>
        </Stack>
      )}
    </Stack>
  )
}
